import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const highlights = [
    { icon: 'ri-fire-line', labelKey: 'hero_highlight_1' },
    { icon: 'ri-map-pin-line', labelKey: 'hero_highlight_2' },
    { icon: 'ri-star-line', labelKey: 'hero_highlight_3' },
    { icon: 'ri-time-line', labelKey: 'hero_highlight_4' },
    { icon: 'ri-whatsapp-line', labelKey: 'hero_highlight_5' },
  ];

  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/3aca7b4f25b4386bcee0afd7be9c4116/f77e28a92349fc21878c3f9934539e9c.png"
          alt="Bucara Burger hero"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/40"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-24 pb-32">
        <div className="max-w-3xl">
          {/* Eyebrow with Colombian flag — visible and elegant */}
          <div className="flex items-center gap-3 mb-6">
            {/* Colombian Flag */}
            <div className="flex flex-col overflow-hidden rounded-sm shadow-lg" style={{ width: '36px', height: '24px' }}>
              <div style={{ flex: '2', backgroundColor: '#FCD116' }}></div>
              <div style={{ flex: '1', backgroundColor: '#003893' }}></div>
              <div style={{ flex: '1', backgroundColor: '#CE1126' }}></div>
            </div>
            <div className="inline-flex items-center gap-2 bg-[#F57F25]/20 border border-[#F57F25]/40 text-[#F57F25] text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
              <span>{t('hero_badge')}</span>
            </div>
          </div>

          {/* Headline */}
          <h1 className="font-black text-white leading-none tracking-tight mb-6 uppercase">
            <span className="block text-3xl md:text-4xl lg:text-5xl">{t('hero_headline_1')}</span>
            <span className="block text-5xl md:text-7xl lg:text-8xl text-[#F57F25]">{t('hero_headline_2')}</span>
            <span className="block text-3xl md:text-4xl lg:text-5xl">{t('hero_headline_3')}</span>
          </h1>

          {/* Subheadline */}
          <p className="text-white/70 text-base md:text-lg leading-relaxed mb-10 max-w-2xl">
            {t('hero_sub')}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => navigate('/menu')}
              className="bg-[#F57F25] hover:bg-[#e06d15] text-black font-bold text-base px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap hover:scale-105"
            >
              {t('btn_view_menu')}
            </button>
            <a
              href="https://wa.me/19862173604?text=Hola%2C%20quiero%20hacer%20un%20pedido.%20%2F%20Hello%2C%20I%20want%20to%20place%20an%20order."
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 border-2 border-white/40 hover:border-[#F57F25] text-white hover:text-[#F57F25] font-bold text-base px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              {t('btn_order_whatsapp')}
            </a>
            <a
              href="tel:+19862173604"
              className="flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-bold text-base px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-lg"></i>
              {t('btn_call_now')}
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Highlights Strip */}
      <div className="absolute bottom-0 left-0 right-0 z-10 bg-black/80 backdrop-blur-sm border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
          <div className="flex flex-wrap justify-center md:justify-between gap-4 md:gap-0">
            {highlights.map((h) => (
              <div key={h.labelKey} className="flex items-center gap-2 text-white/80">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className={`${h.icon} text-[#F57F25] text-lg`}></i>
                </div>
                <span className="text-xs font-semibold tracking-wide uppercase whitespace-nowrap">{t(h.labelKey)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
